import * as React from 'react'
import { inject, observer } from 'mobx-react'
import { AppMainView } from '../../../../components/AppView'
import AppHeader from '../../../../components/AppView/Header'
import { CurrentCompanyStore } from '../../../../stores/CurrentCompanyStore'
import { CurrentUserStore } from '../../../../stores/CurrentUserStore'
import { LoadingAnimation } from '../../../../components/LoadingAnimation'
import { AddAlertModal } from './AddAlertModal'
import { BlazeButton } from '../../../../components/CustomButtons/BlazeButton'
import Helmet from 'react-helmet'
import { BLAZE_COMPANY } from '../../../../constants/general'
import { LowStockNotificationAPI, LowStockNotificationModels } from '@getgreenline/inventory'
import LowStockAlertRecipients from './LowStockAlertRecipients'

interface Props {
  currentCompanyStore?: CurrentCompanyStore
  currentUserStore?: CurrentUserStore
}

interface State {
  alerts?: LowStockNotificationModels.ILowStockNotificationRecipient[]
  showAddModal: boolean
}

@inject('currentCompanyStore', 'currentUserStore')
@observer
export class StockAlerts extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = {
      showAddModal: false,
    }
  }

  componentDidMount() {
    this.loadAlerts()
  }

  async loadAlerts(): Promise<void> {
    const company = this.props.currentCompanyStore?.company

    if (!company) return

    LowStockNotificationAPI.getLowStockNotifications(company.id).then((response) => {
      this.setState({
        alerts: response,
      })
    })
  }

  async deleteAlert(id: number): Promise<void> {
    const company = this.props.currentCompanyStore?.company

    if (!company) return

    LowStockNotificationAPI.deleteLowStockNotification(company.id, id).then(() => {
      this.loadAlerts()
    })
  }

  render() {
    if (!this.state.alerts) {
      return <LoadingAnimation />
    }

    return (
      <>
        <Helmet>
          <title>Inventory | Low Stock Alerts</title>
          <meta name='page-loaded' content='true' />
        </Helmet>
        <AppHeader title='Low stock alerts'>
          <BlazeButton
            buttonProps={{
              type: 'primary',
              icon: 'plus',
              onClick: () => this.setState({ showAddModal: true }),
            }}
            titleProps={{
              title: 'Add alert',
            }}
          />
        </AppHeader>
        <AppMainView>
          <div className='container'>
            <br />
            <div className='p-4 border border-secondary text-muted d-flex'>
              <div>
                <img src={require('../../../../images/inventory-modal.png').default} width={250} />
              </div>

              <div className='pl-4 pr-4'>
                <h3>Receive alerts when your product inventory is low</h3>
                <p>
                  On the master inventory page, configure your low stock levels for each product at
                  each location.
                </p>
                <p>
                  When that threshold is crossed, {BLAZE_COMPANY} will send you an e-mail alert for
                  that specific product.
                </p>
                <br />
                <p>
                  Low stock levels are set under the "Set low stock level" options. Levels can be
                  set to be different per location.
                </p>
              </div>
            </div>
            <br />
            {this.state.alerts && (
              <LowStockAlertRecipients
                recipients={this.state.alerts}
                deleteRecipient={(id) => this.deleteAlert(id)}
              />
            )}
            {this.state.showAddModal && (
              <AddAlertModal
                onSubmit={() => {
                  this.setState({ showAddModal: false })
                  this.loadAlerts()
                }}
                onClose={() => this.setState({ showAddModal: false })}
              />
            )}
          </div>
        </AppMainView>
      </>
    )
  }
}
